var map = {
	"./01.png": 2172,
	"./02.png": 2173,
	"./03.png": 2174,
	"./04.png": 2175,
	"./05.png": 2176,
	"./06.png": 2177,
	"./banner.png": 2178,
	"./default.jpg": 489,
	"./fengjing.png": 2179,
	"./jiaotong.png": 2180,
	"./map.png": 2181,
	"./tongzhi.png": 2182,
	"./xydt.png": 2183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819;


//////////////////
// WEBPACK FOOTER
// ../assets/images/index ^\.\/.*$
// module id = 819
// module chunks = 0